type QueryFilters = Record<string, unknown> | undefined;

export const queryKeys = {
  me: {
    all: () => ["me"] as const,
    detail: () => ["me", "detail"] as const,
  },
  resumes: {
    all: () => ["resumes"] as const,
    list: (filters?: QueryFilters) => ["resumes", "list", filters] as const,
    detail: (id: string) => ["resumes", "detail", id] as const,
    tailored: () => ["resumes", "tailored"] as const,
  },
  jobs: {
    all: () => ["jobs"] as const,
    list: (filters?: QueryFilters) => ["jobs", "list", filters] as const,
    infinite: (filters?: QueryFilters) => ["jobs", "infinite", filters] as const,
    detail: (id: string) => ["jobs", "detail", id] as const,
  },
  jobBatches: {
    all: () => ["jobBatches"] as const,
    list: () => ["jobBatches", "list"] as const,
    detail: (id: string) => ["jobBatches", "detail", id] as const,
  },
  jobProfiles: {
    all: () => ["jobProfiles"] as const,
    list: () => ["jobProfiles", "list"] as const,
    detail: (id: string) => ["jobProfiles", "detail", id] as const,
    stats: () => ["jobProfiles", "stats"] as const,
  },
  applications: {
    all: () => ["applications"] as const,
    list: (filters?: QueryFilters) => ["applications", "list", filters] as const,
    detail: (id: string) => ["applications", "detail", id] as const,
    byJob: (jobId: string) => ["applications", "byJob", jobId] as const,
  },
  autoApply: {
    all: () => ["autoApply"] as const,
    settings: () => ["autoApply", "settings"] as const,
    queue: () => ["autoApply", "queue"] as const,
    queueItem: (id: string) => ["autoApply", "queue", id] as const,
  },
  stats: {
    all: () => ["stats"] as const,
    overview: () => ["stats", "overview"] as const,
    byRange: (range: string) => ["stats", "range", range] as const,
  },
  billing: {
    all: () => ["billing"] as const,
    subscription: () => ["billing", "subscription"] as const,
  },
  notifications: {
    all: () => ["notifications"] as const,
    list: () => ["notifications", "list"] as const,
    unread: () => ["notifications", "unread"] as const,
  },
  onboarding: {
    all: () => ["onboarding"] as const,
    progress: () => ["onboarding", "progress"] as const,
  },
  featureFlags: {
    all: () => ["featureFlags"] as const,
  },
  config: {
    all: () => ["config"] as const,
    featureFlags: () => ["config", "feature-flags"] as const,
  },
  feedback: {
    all: () => ["feedback"] as const,
    list: (filters?: QueryFilters) => ["feedback", "list", filters] as const,
  },
  admin: {
    all: () => ["admin"] as const,
    featureFlags: () => ["admin", "feature-flags"] as const,
    observabilityDashboard: () => ["admin", "observability", "dashboard"] as const,
    userAnalytics: (page = 1) => ["admin", "observability", "user-analytics", page] as const,
    revenueSummary: () => ["admin", "observability", "revenue-summary"] as const,
    checkoutAttempts: () => ["admin", "observability", "checkout-attempts"] as const,
    trialsEnding: (withinDays: number) => ["admin", "observability", "trials", withinDays] as const,
    profiles: () => ["admin", "profiles"] as const,
    observabilityUserRequests: (userId: string) =>
      ["admin", "observability", "users", userId, "requests"] as const,
    jobRetentionStats: () => ["admin", "observability", "job-retention-stats"] as const,
    jobArchiveProposals: () => ["admin", "observability", "job-archive-proposals"] as const,
    activationFunnel: (period: string) => ["admin", "observability", "funnel", period] as const,
    acquisitionChannels: (period: string) =>
      ["admin", "observability", "acquisition-channels", period] as const,
    newUserJourneys: (period: string) =>
      ["admin", "observability", "new-user-journeys", period] as const,
    feedback: (filters?: QueryFilters) => ["admin", "feedback", filters] as const,
  },
  myUsage: {
    all: () => ["me", "usage"] as const,
    paidSpend: () => ["me", "usage", "paid-spend"] as const,
    recentActivity: () => ["me", "usage", "recent-activity"] as const,
  },
  integrations: {
    all: () => ["integrations"] as const,
    list: () => ["integrations", "list"] as const,
  },
  sessions: {
    all: () => ["sessions"] as const,
    list: () => ["sessions", "list"] as const,
  },
  aiPreferences: {
    all: () => ["aiPreferences"] as const,
    detail: () => ["aiPreferences", "detail"] as const,
  },
  system: {
    all: () => ["system"] as const,
    health: () => ["system", "health"] as const,
  },
};
